import { useRef, useState } from "react";
import { toast } from "sonner";
import { Mic, MicOff } from "lucide-react";

const SPEECH_LANG = { en: "en-IN", hi: "hi-IN", te: "te-IN", ta: "ta-IN", mr: "mr-IN", kn: "kn-IN", bn: "bn-IN" };

export function VoiceInput({ lang = "en", onResult, testid = "voice-input" }) {
  const [listening, setListening] = useState(false);
  const recRef = useRef(null);

  const Recognition = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);
  if (!Recognition) return null;

  const toggle = () => {
    if (listening) {
      recRef.current?.stop();
      return;
    }
    const rec = new Recognition();
    rec.lang = SPEECH_LANG[lang] || "en-IN";
    rec.interimResults = false;
    rec.continuous = false;
    rec.onresult = (e) => {
      const transcript = Array.from(e.results).map((r) => r[0].transcript).join(" ").trim();
      if (transcript) onResult(transcript);
    };
    rec.onerror = (e) => {
      setListening(false);
      if (e.error === "not-allowed") toast.error("Microphone access denied — allow mic permission to use voice input");
    };
    rec.onend = () => setListening(false);
    recRef.current = rec;
    try {
      rec.start();
      setListening(true);
    } catch {
      setListening(false);
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid={testid}
      title={listening ? "Stop voice input" : "Speak your answer"}
      className={`absolute right-2.5 top-2.5 w-8 h-8 rounded-full flex items-center justify-center transition-all ${
        listening
          ? "bg-red-500 text-white animate-pulse shadow-[0_0_16px_rgba(239,68,68,0.6)]"
          : "bg-white/5 border border-white/10 text-slate-400 hover:text-[#FF8800] hover:border-[#FF8800]/40"
      }`}
    >
      {listening ? <MicOff className="w-3.5 h-3.5" /> : <Mic className="w-3.5 h-3.5" />}
    </button>
  );
}
